import React, { useContext } from 'react';
import PlaceBookmarks from './BookmarkLists/PlaceBookmarks';
import StoryBookmarks from './BookmarkLists/StoryBookmarks';
import TrailBookmarks from './BookmarkLists/TrailBookmarks';
import NoBookmarks from './NoBookmarks';
import {
	PlaceFactory,
	PlaceQuery,
} from '../../../models/factories/PlaceFactory';
import { ExplorerContext } from '../../../application/config';
import { useAppSelector } from '../../../state/hooks';
import { RootState } from '../../../state/store';
import { isEqual } from 'lodash';
import {
	TrailFactory,
	TrailQuery,
} from '../../../models/factories/TrailFactory';
import {
	StoryFactory,
	StoryQuery,
} from '../../../models/factories/StoryFactory';
import { selectPrefs } from '../../../state/selectors';
import {
	filterPlacesByAccessibility,
	filterStoriesByAccessibility,
	filterTrailsByAccessibility,
	sortPlacesByPreferences,
	sortStoriesByPreferences,
	sortTrailsByPreferences,
} from '../../../models/helpers/preferenceRanking';

type BookmarksProps = {
	listKey: string;
};

const BookmarksHandler: React.FC<BookmarksProps> = ({ listKey }) => {
	const AppData = useContext(ExplorerContext);
	const bookmarkedPlaces = useAppSelector(
		(state: RootState) => state.bookmarks.places,
		isEqual,
	);
	const bookmarkedTrails = useAppSelector(
		(state: RootState) => state.bookmarks.trails,
		isEqual,
	);
	const bookmarkedStories = useAppSelector(
		(state: RootState) => state.bookmarks.stories,
		isEqual,
	);
	const userPrefs = useAppSelector(selectPrefs, isEqual);
	const placeQuery: PlaceQuery = {
		filter: { id: bookmarkedPlaces },
	};
	const trailQuery: TrailQuery = {
		filter: { id: bookmarkedTrails },
	};
	const storyQuery: StoryQuery = {
		filter: { id: bookmarkedStories },
	};
	const selectedPlaceList = PlaceFactory.filter(
		AppData.features?.all_places ?? PlaceFactory.getEmpty(),
		placeQuery,
	);
	const selectedTrailList = TrailFactory.filter(
		AppData.features?.all_trails ?? TrailFactory.getEmpty(),
		trailQuery,
	);
	const selectedStoryList = StoryFactory.filter(
		AppData.features?.all_stories ?? StoryFactory.getEmpty(),
		storyQuery,
	);
	const prioritisedPlaces = sortPlacesByPreferences(
		filterPlacesByAccessibility([...selectedPlaceList.places], userPrefs),
		userPrefs,
	);
	const prioritisedTrails = sortTrailsByPreferences(
		filterTrailsByAccessibility([...selectedTrailList.trails], userPrefs),
		userPrefs,
	);
	const prioritisedStories = sortStoriesByPreferences(
		filterStoriesByAccessibility([...selectedStoryList.stories], userPrefs),
		userPrefs,
	);

	// <BookmarkList list={list} />

	// case "trails" && trails.length > 0
	// default retrun </ nobookmarks>
	const renderList = () => {
		if (listKey === 'trails' && prioritisedTrails.length > 0) {
			return <TrailBookmarks trails={prioritisedTrails} />;
		} else if (
			listKey === 'places' &&
			prioritisedPlaces.length > 0
		) {
			return <PlaceBookmarks places={prioritisedPlaces} />;
		} else if (
			listKey === 'stories' &&
			prioritisedStories.length > 0
		) {
			return <StoryBookmarks stories={prioritisedStories} />;
		} else {
			return <NoBookmarks listKey={listKey} />;
		}
	};
	return <>{renderList()}</>;
};

export default BookmarksHandler;
